import SiafLiteApiRepository from "../../external/siafLiteApi";
import SessionService from "../session.service";

class NotificacaoService {
  constructor() {
    this.urlBase = "/notificacao";
    this.urlBaseEvent = `/event${this.urlBase}`;
    this.sessionService = new SessionService();
  }

  async getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  async marcarTodasComoLida() {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/marcar-como-lida`,
    ).get();
  }

  async marcarComoLida(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/marcar-como-lida/${id}`,
    ).get();
  }

  async enviarEmail(body) {
    const dadosEmpresa = this.sessionService.getEmpresa();
    const empresa = this.sessionService.getEmpresaRelatorio();
    empresa.telefone = empresa.telefone || dadosEmpresa?.celular;
    const emailRemetente =
      dadosEmpresa.configuracoes?.emailPersonalizado ??
      "contato-siaf-evolution";
    const nomeRemetente = empresa.fantasia || empresa.razaoSocial;
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/send-email`).post({
      ...body,
      from: { email: `${emailRemetente}@adsoft.com.br`, name: nomeRemetente },
      empresa,
    });
  }
}

export default NotificacaoService;
